  // Select all cart item containers
  const cartItems = document.querySelectorAll('[data-productid]');
  const itemsData = [];

  cartItems.forEach(item => {
    const productId = item.getAttribute('data-productid');

    // Check if the item contains the "Try before you buy" description
    const tryBeforeText = item.querySelector('.subscription-description');
    const isTryAtHome = tryBeforeText && tryBeforeText.textContent.toLowerCase().includes('try before');

    itemsData.push({
      id: productId,
      tryAtHome: !!isTryAtHome
    });
  });

  // Save to localStorage
  localStorage.setItem('cartProducts', JSON.stringify(itemsData));

  console.log('Saved to localStorage:', itemsData);